export const TEST_IDS = {
    contractors: {
        accordion: 'contractors-accordion',
        table: {
            id: 'contractors-table'
        },
        newContractorFormFields: {
            cuit: 'newContractorForm-input-cuit',
            companyActivity: 'newContractorForm-input-companyActivity',
            companyType: 'newContractorForm-input-companyType',
            employeeQuantity: 'newContractorForm-input-employeeQuantity'
        }
    },
    responsibles: {
        accordion: 'responsibles-accordion',
        table: {
            id: 'responsibles-table'
        },
        newResponsibleFormFields: {
            name: 'newResponsibleForm-input-name',
            surname: 'newResponsibleForm-input-surname',
            cuit: 'newResponsibleForm-input-cuit',
            charge: 'newResponsibleForm-input-charge',
            respresentation: 'newResponsibleForm-input-respresentation',
            status: 'newResponsibleForm-input-status',
            habilitationTitle: 'newResponsibleForm-input-habilitationTitle',
            otherHabilitationTitle: 'newResponsibleForm-input-otherHabilitationTitle',
            licenceNumber: 'newResponsibleForm-input-licenceNumber',
            grantingEntity: 'newResponsibleForm-input-grantingEntity',
            professionalType: 'newResponsibleForm-input-professionalType',
            hoursQuantity: 'newResponsibleForm-input-hoursQuantity'
        }
    }
};
